import { jwtDecode } from 'jwt-decode'
import { useContext, useEffect, useState } from 'react'

import { AuthContext } from '../contexts'

interface DecodedToken {
  exp: number
  sub: string
  role: string
}

const useAuth = () => {
  const { isAuth } = useContext(AuthContext)
  const [user, setUser] = useState<DecodedToken | string | null>(null)

  useEffect(() => {
    if (isAuth) {
      try {
        const decoded: DecodedToken = jwtDecode(isAuth)
        const token = sessionStorage.getItem('token') || localStorage.getItem('token')
        // const userSession = sessionStorage.getItem('userSession') || localStorage.getItem('userSession')
        const payload = token?.replaceAll('"', '').split('.')[1]
        const payloadDecoded = JSON.parse(atob(String(payload)))

        // if (decoded.role !== JSON.parse(userSession || '{}').role) {
        //   setUser('invalid-token')
        // } else {
        //   setUser(decoded)
        // }

        if (decoded.role !== payloadDecoded.role) {
          setUser('invalid-token')
        } else {
          setUser(decoded)
        }
      } catch (error) {
        console.error('Invalid token:', error)
        setUser('invalid-token')
      }
    } else {
      setUser(null)
    }
  }, [isAuth])

  return user
}

export default useAuth
